import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { userLoginV2Action, getUserDetailsAction } from '../../../store/authSlice';
import { resetAllStates } from '../../../store';
export const useOrganisationList = () => {
    // ========== REDUX SELECTORS ==========
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const organisations = useSelector((state) => state.auth.userOrganisations.response?.data?.organisations || []);
    const loading = useSelector((state) => state.auth.userOrganisations.loading);
    const userId = useSelector((state) => state.auth.userOrganisations.response?.data?.userId);
    // ========== MEMOIZED VALUES ==========
    const menuItems = useMemo(() => [
        {
            key: 'logout',
            icon: 'log-out-02',
            label: 'Logout',
            onClick: () => handleLogout(),
        },
    ], []);
    // ========== HANDLERS ==========
    const handleLogout = useCallback(() => {
        resetAllStates(dispatch);
        navigate('/');
    }, [dispatch, navigate]);
    const handleOrgClick = useCallback(async (orgId) => {
        if (!userId) {
            message.error('User ID not found. Please try logging in again.');
            return;
        }
        try {
            await dispatch(userLoginV2Action({ userId, orgId }));
            // Get user details after successful login
            await dispatch(getUserDetailsAction());
            navigate('/site-list');
        }
        catch (error) {
            console.error('Error during organization login:', error);
            message.error('Failed to login to organization. Please try again.');
        }
    }, [dispatch, navigate, userId]);
    return {
        // State
        organisations,
        loading,
        userId,
        // Handlers
        handleLogout,
        handleOrgClick,
        // Memoized values
        menuItems,
    };
};
